define('modules/editor/views/elements/social_twitter',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";
  var Backbone = require("backbone");

  module.exports = Backbone.View.extend({
    tagName: "a",
    className: "twitter-share-button",
    attributes: {
      "href": "https://twitter.com/share"
    },
    render: function() {
      module.exports.__super__.render.apply(this, arguments);
      var layout = this.model.get("counter")? "" : "none",
          url = this.model.get("sharedUrl");
      this.$el.attr("data-count", layout);
      if (url) this.$el.attr("data-url", url);
      return this;
    }
  });
});

